export default {
  titulos: {
    listagem: 'Comunicação com Instrumentos',
    editar: 'Editar Comunicação com Instrumentos',
    novo: 'Nova Comunicação com Instrumento',
  },
  cadastro_sucesso: 'Comunicação com Instrumento salvo com sucesso!',
  exclusao_sucesso: 'Comunicação com Instrumento excluído com sucesso!',
  titulo_modal: 'Instrumento Padrão',
  tabela: {
    nome: 'Instrumento Padrão',
    tipo_instrumento: 'Tipo do Instrumento',
    tipo_comunicacao: 'Tipo de Comunicação',
  },
  formulario: {
    tipo_comunicacao: 'Tipo de Comunicação',
    instrumento_padrao: 'Instrumento Padrão',
    baudrate: 'BaudRate',
    data_bits: 'Data Bits',
    stopbits: 'StopBits',
  },
};
